exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".backbtn-toggler[data-v-2f5ba638] {\n  border: none;\n  background-color: transparent;\n}\n.backbtn-toggler svg[data-v-2f5ba638] {\n    transform: rotate(90deg);\n}\n", ""]);

// exports
